export function normalizeSize(size) {
  return size || "md";
}
export function createSizeAdapter(adapter) {
  return size => adapter[normalizeSize(size)];
}
export function adaptSize(size, adapter) {
  return adapter[normalizeSize(size)];
}